import React, { Component, Fragment, memo } from "react";
import { withRouter } from "react-router-dom";
import Modal from "react-modal";
import RadioButton from '../../../components/UI/radioButton/radiobutton.jsx';

function modalReversion(props) {

    const customStyles = {
        content: {
            position: "fixed",
            position: "absolute",
            top: "25%",
            left: "25%",
            right: "25%",
            bottom: "25%",
            with: "50%",
            height: "50%",
            padding: "5px",
        },
        overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.75)",
        },
    };

    return (
        <Fragment>
            <Modal
                isOpen={props.showModal}
                contentLabel={props.contentLabel}
                style={customStyles}
                ariaHideApp={false}
            >
                <div className="">
                    <div className="">
                        <div className="modal-header">
                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                                onClick={props.cerrarModal}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <h2 className="modal-title" id="ModalLabel">
                                Reversión de Asientos
                            </h2>
                        </div>
                        <div className="modal-body" style={{ textAlign: 'center' }}>
                            <div className="row">
                                <h4>Asiento "{props.Datos.pNumero.value}"</h4>
                            </div>
                            <div className='row'>
                                <RadioButton id="TipoReversion" col="12" attributes={props.Datos.TipoReversion.attributes} value={props.tipoReversion} datos={props.listaTipoReversion} onChange={props.handleRadioButtonTipo} horizontal={true} label={props.Datos.TipoReversion.attributes.label} />
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div class="tooltip2">
                                <span class="tooltiptext2">Cerrar</span>
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-dismiss="modal"
                                    onClick={props.cerrarModal}
                                >
                                    Cerrar
                                </button>
                            </div>

                            <div class="tooltip2">
                                <span class="tooltiptext2">Reversar</span>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={props.handleReversar}
                                >
                                    Reversar
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </Modal>
        </Fragment>
    );
}
export default withRouter(memo(modalReversion))